import Highcharts from "highcharts";

//Timeline: Skipped legend symbol;
Highcharts.SVGRenderer.prototype.symbols.skipped = function (x: number, y: number, w: number, h: number) {
  const radius = w / 2;
  return [
    // circle
    'M', x + radius, y,
    'A', radius, radius, 0,1,1, x + radius, y + h,
    'A', radius, radius, 0,1,1, x + radius, y,

    // -
    'M', x + 3, y + radius,
    'L', x+ w - 3, y + radius,
  ];
};
